import { GridColDef } from "@mui/x-data-grid";
import { LocalizedStrings } from "react-localization";
import { IIntervention } from "../../../components/custom/Site/AllowedRoutes/Modules/WFM/_models/Intervention";
import { IInterventionEditFormProps } from "../../../components/custom/Site/AllowedRoutes/Modules/WFM/InterventionManagement/InterventionEditForm/InterventionEditForm";
import InterventionEditFormATENA from "../WFM/InterventionEditFormATENA";

export const customInterventionColumns = (lang?: LocalizedStrings<any>): GridColDef<IIntervention, number | string | Date>[] => [
    {
        field: 'odi',
        headerName: "P.IVA/CF",
        width: 150
    },
    {
        field: 'witness',
        headerName: lang?.witness,
        width: 200
    },
    {
        field: 'district',
        headerName: lang?.provincia,
    },
];

export const customInterventionEditForm = (props: IInterventionEditFormProps) => <InterventionEditFormATENA {...props} />;